import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function NewsSection() {
  const displayArticles = articles.slice(0, 3);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                最新资讯
              </h2>
              <p className="text-sm text-foreground-500 mt-2">
                影视动态 · 平台攻略 · 观影指南
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {displayArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative w-full aspect-[16/10] overflow-hidden">
                  <img
                    src={article.cover}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="px-2 py-0.5 bg-accent-100 text-accent-800 text-[11px] font-medium rounded whitespace-nowrap">
                      {article.category}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{article.date}</span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2 leading-snug">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mb-3">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <span>{article.author}</span>
                    <span className="whitespace-nowrap">{article.readTime} 阅读</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}